import { useEffect, useRef } from 'react';
import { useFormikContext } from 'formik';
import { useSelector } from 'react-redux';

// Place inside a <Formik>. When the app language switches, it hands the form's current (unsaved)
// values to onLanguageChange so the form can reuse them instead of the refetched initialValues.
// Values live only in memory, so a hard reload still starts from the server data.
const KeepValuesOnLanguageChange = ({ onLanguageChange }) => {
  const { values, dirty } = useFormikContext();
  const { language } = useSelector((state) => state.content);

  const formRef = useRef({ values, dirty });
  const isFirstRender = useRef(true);
  formRef.current = { values, dirty };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    // Only keep values the user actually changed, so untouched forms still load fresh server data.
    if (formRef.current.dirty) onLanguageChange(formRef.current.values);
  }, [language]);

  return null;
};

export default KeepValuesOnLanguageChange;
